package modysy

import scala.scalajs.js
import scala.scalajs.js.annotation.JSImport

@js.native
@JSImport("file-saver", JSImport.Namespace)
object FileSaver extends js.Object {
  def saveAs(blobFileData: js.Any,
             filename: js.UndefOr[String] = js.undefined,
             disableAutoBom: js.UndefOr[Boolean] = js.undefined): Unit =
    js.native
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/FileSaver.scala